/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accShareGroupsActions', [
        'template',
        'ShareGroupsMembersModal',
        'ShareGroupsModal',
        function (
            template,
            ShareGroupsMembersModal,
            ShareGroupsModal
        ) {
            return {
                scope: false,
                require: 'ShareGroupsController',
                templateUrl: template('share_groups/_share_groups_actions'),
                controller: ['$scope', ($scope) => {
                    $scope.openGroupModal = () =>
                        ShareGroupsModal($scope.selectedGroup)
                            .then((createdGroup) => {
                                if (createdGroup != null) {
                                    $scope.selectGroup(createdGroup.uuid);
                                }

                                $scope.table.reload();
                            });

                    $scope.openViewMembersModal = () =>
                        ShareGroupsMembersModal($scope.selectedGroup)
                            .then(() => {
                                $scope.clearSelection();
                                $scope.table.reload();
                            });
                }]
            };
        }
    ]);
